/** biome-ignore-all lint/style/useNamingConvention: camel case */
import PropTypes from 'prop-types';
import {Input} from '~library/atoms/Input';
import {Typography} from '~library/atoms/Typography';
import {SearchLineIcon} from '~library/svg/SearchLineIcon';

import {pebble} from '~libSass/base/_exports.sass';

const NumGuests = ({status, count}) => {
  const prettyStatus = status.toLowerCase().replaceAll(' ', '_');
  return (
    <div className="wic__num-guests-wrapper">
      {/** biome-ignore lint/a11y/useAriaPropsSupportedByRole: div cant have label */}
      <div
        className={`wic__num-guests ${prettyStatus}`}
        data-qa-id={`${prettyStatus}-count`}
        data-qa-value={count}
        aria-label={`${prettyStatus}-count-${count}`}
      >
        <Typography variant="paragraph3" classNames="wic__guest-count">
          {count}
        </Typography>
      </div>
      <Typography variant="paragraph3">{status}</Typography>
    </div>
  );
};

NumGuests.propTypes = {
  status: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
};

export const WhoIsComingHeader = ({yes, maybe, no, no_reply: noReply, query, onQueryChange}) => (
  <div className="view-invitation__who-is-coming-header">
    <div className="wic__guest-counts">
      <NumGuests status="Yes" count={yes} />
      {maybe !== undefined && <NumGuests status="Maybe" count={maybe} />}
      <NumGuests status="No" count={no} />
      <NumGuests status="No Reply" count={noReply} />
    </div>
    <div className="wic__guest-actions">
      <Input
        data-qa-id="search-guests"
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
        startAdornment={<SearchLineIcon ratio={0.5} color={pebble} />}
        placeholder="Search guests"
      />
    </div>
  </div>
);

WhoIsComingHeader.propTypes = {
  yes: PropTypes.number.isRequired,
  maybe: PropTypes.number,
  no: PropTypes.number.isRequired,
  no_reply: PropTypes.number.isRequired,
  query: PropTypes.string,
  onQueryChange: PropTypes.func,
};
